import { CREATE_MODAL as type } from './';

export default payload => ({ type, payload });
